<template>
    <div class="upcoming-events-calendar-card-calendar">
        <div class="upcoming-events-calendar-card-calendar-component">
            <div class="upcoming-events-calendar-card-calendar">
                <div class="upcoming-events-calendar-card-calendar-component">
                    <v-calendar
                    :selectedDate="selectedDate"
                    @dayClick="dayClick"
                    :events = "_events"
                    parentClass='upcoming-events-calendar-card-calendar-component'
                    />
                </div>
            </div>
        </div>
        <v-divider class="upcoming-events-calendar-card-calendar-divider"/>
        <div class="upcoming-events-calendar-card-info-component">
            <upcoming-events-calendar-card-info 
            :date="selectedDate"
            :nearestEvent="nearestEvent"
            :events="selectedDateEvents"/>
        </div>
    </div>
</template>
<script>

import  UpcomingEventsCalendarCardInfo from '@/components/calendarCard/UpcomingEventsCalendarCardInfo.vue';
import VCalendar from '@/components/v-calendar/VCalendar.vue';
import { useEventsStore } from '@/store/events'

export default {
    name: 'UpcomingEventsCalendarCard',
    components: {
        UpcomingEventsCalendarCardInfo,
        VCalendar
    },
    data(){
        let events = [{
            date: new Date(2018, 0, 1),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'КИИ'
        },{
            date: new Date(2018, 0, 10),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'КИИ'
        },{
            date: new Date(2018, 0, 22),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'КИИ'
        },{
            date: new Date(2018, 0, 4),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'ГИСИС'
        },{
            date: new Date(2018, 0, 10),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'ГИСИС'
        },{
            date: new Date(2018, 0, 15),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'ГИСИС'
        },{
            date: new Date(2018, 0, 12),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'БУКВЫ'
        },{
            date: new Date(2018, 0, 26),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'БУКВЫ'
        },{
            date: new Date(2018, 0, 15),
            text: 'XXI Национальная конференция по искусственному интеллекту с международным участием (КИИ-2023)',
            eventName: 'БУКВЫ'
        }   
    ]
        let colors = ['red', 'blue', 'green', 'yellow']
        return {
            selectedDate_: new Date(2018, 0, 15),
            colors: colors,
            events: events
        }
    },
    computed: {
        _events(){
            const eventsStore = useEventsStore()
            let return_events = []
            for (let event of eventsStore.eventsFilters){
                let color = eventsStore.getEventColor(event)
                if (color == "#0635AC")
                    color = "blue"
                if (color == "#00AA8A")
                    color = "green"
                if (color == "#F24956")
                    color = "red"
                if (color == "#AA0075")
                    color = "red"
                let text = event.description
                let eventName = event.summary
                if (text === null)
                    text = ''
                if (eventName === null)
                    eventName = ''
                let filters = ''
                for (let filter of event.filers){
                    filters += '#' + filter.name +' '
                }
                return_events.push({
                    'date': event.date_start,
                    'date_end': event.date_end,
                    'text': text,
                    'eventName': filters,
                    'color': color
                })
            }
            return return_events
        },
        selectedDate(){
            const eventsStore = useEventsStore()
            return eventsStore.selectedDate
        },
        eventColors(){
            let _eventColors = {}
            let color_index = 0
            for (let event of this.events) {
                if(!Object.keys(_eventColors).find((key)=>key==event.eventName)){
                    _eventColors[event.eventName] = this.colors[color_index]
                    if (color_index == color_index.length -1){
                        color_index = 0
                    }
                    else
                        color_index += 1
                }
            }
            return _eventColors
        },
        calendarEvents(){
            let _events = []
            let eventNamesDescription =[]
            let added_event = false
            let chosen_color = ''
            for (let event of this.events){
                added_event = false
                for(let description of eventNamesDescription){
                    if (description.eventName == event.eventName){
                        added_event = true
                        break
                    }
                }
                if (!added_event){
                    eventNamesDescription.push({eventName: event.eventName})
                    chosen_color = this.eventColors[event.eventName]
                    _events.push({'dates':[],
                                  'dot':chosen_color,
                                  'eventName': event.eventName})
                }
                for (let _event of _events){
                    if (_event.eventName == event.eventName){
                        _event.dates.push(event.date)
                    }
                }
            }
            return _events
        },
        selectedDateEvents(){
            if(!(this.selectedDate instanceof Date))
                return []
            function getDateForCompare(date){
                return date.getDate() + date.getMonth() * 100 + date.getFullYear() * 10000                
            }
            let __events = this._events.filter((event) => getDateForCompare(event.date) <= getDateForCompare(this.selectedDate) && 
                                                          getDateForCompare(this.selectedDate) <= getDateForCompare(event.date_end))
            return __events
        },
        nearestEvent() {
            let nearestDay = ''
            if (this.selectedDateEvents.length > 0)
                return nearestDay
            if(!(this.selectedDate instanceof Date))
                return nearestDay
            let eventDifference = ''
            let nearestDayDifference = ''
            for (let event of this.events){
                if (nearestDay == ''){
                    nearestDay = event.date
                    continue
                }
                eventDifference = Math.abs(event.date.getTime() - this.selectedDate.getTime()) 
                nearestDayDifference = Math.abs(nearestDay.getTime() - this.selectedDate.getTime())
                if (eventDifference < nearestDayDifference) {
                    nearestDay = event.date
                }
            }
            return nearestDay
        }
    },
    methods:{
        dayClick(day){
            const eventsStore = useEventsStore()
            eventsStore.setSelectedDate(day)
            eventsStore.setDateIsSelected(true)
        }
    }
}

</script>
